import { inject } from 'mobx-react';
import * as React from 'react';

import { PageStore } from 'bernie-core';

import { CustomerNotification, CustomerNotificationLocation } from '@shared-ui/customer-notifications';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { classNames } from 'uitk-react-utils';

import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';

interface CustomerNotificationsProps {
  location: CustomerNotificationLocation;
  page?: PageStore;
  classes?: string;
  regionId?: string;
  startDate: string | null;
  endDate: string | null;
}

export const CustomerNotifications: React.FC<CustomerNotificationsProps> = inject('page')(
  React.memo((props: CustomerNotificationsProps) => {
    const { location, page, classes, regionId, startDate, endDate } = props;

    if (!page || !page.pageId) {
      return null;
    }

    const customerNotificationsClasses = classNames('all-t-padding-two', { [classes]: classes });
    let customerNotificationInputs;

    if (Number(regionId)) {
      customerNotificationInputs = {
        notificationLocation: location,
        xPageId: page.pageId,
        optionalContext: {
          journeyCriterias: [
            {
              destination: {
                regionId: regionId,
              },
              dateRange: {
                start: startDate,
                end: endDate,
              },
            },
          ],
        },
      };
    } else {
      customerNotificationInputs = {
        notificationLocation: location,
        xPageId: page.pageId,
      };
    }

    if (location && location === CustomerNotificationLocation.FOOTER) {
      return (
        <div className={customerNotificationsClasses} data-stid={'footer-customer-notification'}>
          <SimpleLazyLoadWrapper>
            <CustomerNotification inputs={customerNotificationInputs} />
          </SimpleLazyLoadWrapper>
        </div>
      );
    }

    return (
      <Experiment name={'Lshop_Travel_Advisory'}>
        <ExperimentControl />
        <ExperimentVariant bucket={1}>
          <div className={customerNotificationsClasses}>
            <CustomerNotification inputs={customerNotificationInputs} />
          </div>
        </ExperimentVariant>
      </Experiment>
    );
  })
);
